export default "__VITE_ASSET__Bc5K2gFE__"